/* Biontech · landings lp-*. Cuenta atrás, selector de packs y barra fija. */
(function () {
  function pad(n) { return String(n).padStart(2, "0"); }

  function finDe(el) {
    var modo = el.dataset.mode || "evergreen";
    var ahora = Date.now();
    if (modo === "fecha") {
      var t = Date.parse((el.dataset.end || "").replace(" ", "T"));
      return isNaN(t) ? ahora : t;
    }
    if (modo === "diario") {
      var d = new Date(); d.setHours(24, 0, 0, 0); return d.getTime();
    }
    var horas = parseFloat(el.dataset.hours || "24") || 24;
    var clave = "lp_cd_" + (el.dataset.key || "landing");
    var fin = 0;
    try { fin = +localStorage.getItem(clave) || 0; } catch (e) {}
    if (!fin || fin <= ahora) {
      fin = ahora + horas * 3600e3;
      try { localStorage.setItem(clave, fin); } catch (e) {}
    }
    return fin;
  }

  function pinta(el) {
    var fin = el._fin || (el._fin = finDe(el));
    var s = Math.max(0, Math.floor((fin - Date.now()) / 1000));
    if (s === 0) {
      if (el.dataset.mode === "fecha") {
        var cont = el.closest("[data-cd-wrap]");
        if (el.dataset.hide === "true" && cont) { cont.style.display = "none"; return; }
        if (el.dataset.expired) { el.textContent = el.dataset.expired; return; }
      } else { el._fin = finDe(el); s = Math.max(0, Math.floor((el._fin - Date.now()) / 1000)); }
    }
    var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), x = s % 60;
    if (el.dataset.style === "boxes") {
      var fr = (document.documentElement.lang || "").indexOf("fr") === 0;
      var cajas = (d > 0 ? [[d, fr ? "j" : "días"]] : []).concat([[h, "h"], [m, "min"], [x, fr ? "s" : "seg"]]);
      el.innerHTML = cajas.map(function (c) { return "<b>" + pad(c[0]) + "<small>" + c[1] + "</small></b>"; }).join("");
    } else {
      el.textContent = (d > 0 ? d + "d " : "") + pad(h) + ":" + pad(m) + ":" + pad(x);
    }
  }

  function relojes() {
    var els = document.querySelectorAll("[data-lp-cd]");
    if (!els.length) return;
    els.forEach(pinta);
    setInterval(function () { els.forEach(pinta); }, 1000);
  }

  function packs() {
    document.querySelectorAll("[data-lp-packs]").forEach(function (caja) {
      var sec = caja.closest("section") || document;
      var boton = sec.querySelector("[data-lp-pack-cta]");
      caja.querySelectorAll("[data-lp-pack]").forEach(function (p) {
        p.addEventListener("click", function (ev) {
          if (!boton) return;
          ev.preventDefault();
          caja.querySelectorAll("[data-lp-pack]").forEach(function (o) { o.classList.remove("is-on"); o.setAttribute("aria-checked", "false"); });
          p.classList.add("is-on"); p.setAttribute("aria-checked", "true");
          boton.href = p.dataset.url;
        });
      });
    });
  }

  function barra() {
    var b = document.querySelector("[data-lp-sticky]");
    if (!b) return;
    document.body.classList.add("has-sticky");
    if (b.classList.contains("lp-sticky--mobile")) document.body.classList.add("has-sticky-m");
    var umbral = parseInt(b.dataset.after || "500", 10);
    function mira() { b.classList.toggle("is-on", window.scrollY > umbral); }
    window.addEventListener("scroll", mira, { passive: true }); mira();
  }

  function flechas() {
    document.querySelectorAll("[data-lp-rev]").forEach(function (w) {
      var pista = w.querySelector(".lp-reviews");
      w.querySelectorAll("[data-dir]").forEach(function (b) {
        b.addEventListener("click", function () {
          var c = pista.querySelector(".lp-review");
          var paso = c ? c.getBoundingClientRect().width + 24 : pista.clientWidth;
          pista.scrollBy({ left: paso * parseInt(b.dataset.dir, 10), behavior: "smooth" });
        });
      });
    });
  }

  function videos() {
    var vs = document.querySelectorAll("video[data-lp-src]");
    if (!vs.length) return;
    function carga(v) { if (!v.src) { v.src = v.dataset.lpSrc; v.play().catch(function () {}); } }
    if (!("IntersectionObserver" in window)) { vs.forEach(carga); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) carga(e.target);
        else if (e.target.src) e.target.pause();
        if (e.isIntersecting && e.target.src && e.target.paused) e.target.play().catch(function () {});
      });
    }, { rootMargin: "200px 0px" });
    vs.forEach(function (v) { io.observe(v); });
  }

  function init() { relojes(); packs(); barra(); flechas(); videos(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();
